





























import Mixin from '@/mixin';
import { Component, Emit, Prop } from 'vue-property-decorator';

@Component({
  name: 'v-search-bar'
})
export default class VSearchBar extends Mixin {
  @Prop() value?: string;
  public showInput = false;
  public show = false;

  @Emit()
  public onTextChange(value: string) {}
}
